import { POST_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS } from './types'
import { ACCEPT_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS } from './types'

export const createPostTermsAndCondtionAndPriceListSuccessAction = () => ({
  type: POST_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS,
})
export const createAcceptTermsAndCondtionAndPriceListSuccessAction = () => ({
  type: ACCEPT_TERMS_AND_CONDITION_AND_PRICE_LIST_SUCCESS,
})
